import { Card, CardContent, CardTitle } from "@babybjorn/ui";
import type { StoryblokRichTextNode } from "@storyblok/react";
import type { ReactElement } from "react";
import ThreeUp from "../../components/ThreeUp";
import ThreeUpItem from "../../components/ThreeUp/components/ThreeUpItem/ThreeUpItem";
import GridItem from "../../components/general/GridItem";
import ImageContainer from "../../components/general/ImageContainers";
import RichText from "../../components/general/RichText";
import { getUrlFromStoryblokLink } from "../../utils/storyblok/urls";
import { notNull, notUndefined } from "../../utils/type-guards/general";

const ThreeUpModule = ({
	headline,
	label,
	items,
}: Queries.ThreeUpModuleFragment) => {
	const itemsProps = items
		?.filter(notNull)
		.map((item) => {
			if (!item.image) return;

			const button = item.button?.[0];
			const buttonProps =
				button && button.link && typeof button.label === "string"
					? {
							href: getUrlFromStoryblokLink(button.link),
							label: button.label,
							target: button.link.target ?? undefined,
							icon: button.icon ?? undefined,
						}
					: undefined;

			return {
				uid: item._uid,
				headline: item.headline ?? "",
				image: item.image,
				text: item.text ?? "",
				cta: buttonProps ?? undefined,
				attributes: item.attributes ?? [],
			};
		})
		.filter(notUndefined);

	return itemsProps ? (
		<GridItem>
			<ThreeUp headline={headline ?? ""} label={label ?? ""}>
				{itemsProps.map((item) => (
					<>
						{item.attributes.includes("playing-card") ? (
							<Card key={item.uid} variant="rounded" className="bg-white">
								<ImageContainer
									imgSrc={item.image.filename ?? ""}
									alt={item.image.alt ?? ""}
									className="aspect-[1.14/1] w-full rounded-t-[inherit]"
									objectFit="cover"
								/>

								<CardContent className="border-inherit">
									<CardTitle>{item.headline}</CardTitle>
									<RichText
										className="[&>*]:!text-gray-2"
										content={item.text as StoryblokRichTextNode<ReactElement>}
									/>
								</CardContent>
							</Card>
						) : (
							<ThreeUpItem
								key={item.uid}
								image={item.image}
								headline={item.headline}
								text={item.text as StoryblokRichTextNode<ReactElement>}
								cta={item.cta}
							/>
						)}
					</>
				))}
			</ThreeUp>
		</GridItem>
	) : null;
};

export default ThreeUpModule;
